import { render, staticRenderFns } from "./LiveClasses.vue?vue&type=template&id=2cc101fc&scoped=true"
import script from "./LiveClasses.vue?vue&type=script&lang=js"
export * from "./LiveClasses.vue?vue&type=script&lang=js"
import style0 from "./LiveClasses.vue?vue&type=style&index=0&id=2cc101fc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc101fc",
  null
  
)

export default component.exports